export default __webpack_public_path__ + "static/media/Kaushik.cd3e6eb9.png";